module.exports = __webpack_public_path__ + "img/扬翔-1.d53c287e.png";